import useAnalyticsManager, {
  ANALYTICS_EVENT_POST_SHARE_FACEBOOK,
  ANALYTICS_EVENT_POST_SHARE_LINKED_IN,
  ANALYTICS_EVENT_POST_SHARE_LINK,
  ANALYTICS_EVENT_POST_SHARE_WHATS_APP,
  ANALYTICS_EVENT_POST_SHARE_MESSENGER,
  ANALYTICS_EVENT_POST_SHARE_VIBER,
} from '@/composables/analytics/analyticsManager'
import { Post } from '@/model/data-object/Post'
import { ref } from 'vue'

export default function usePostShareManager(post: Post) {
  const { propagateAnalyticsEvent } = useAnalyticsManager()

  const propagateFacebookEvent = () => {
    propagateAnalyticsEvent(post, ANALYTICS_EVENT_POST_SHARE_FACEBOOK)
  }

  const propagateMessengerEvent = () => {
    propagateAnalyticsEvent(post, ANALYTICS_EVENT_POST_SHARE_MESSENGER)
  }

  const propagateViberEvent = () => {
    propagateAnalyticsEvent(post, ANALYTICS_EVENT_POST_SHARE_VIBER)
  }

  const propagateWhatsAppEvent = () => {
    propagateAnalyticsEvent(post, ANALYTICS_EVENT_POST_SHARE_WHATS_APP)
  }

  const propagateLinkedInEvent = () => {
    propagateAnalyticsEvent(post, ANALYTICS_EVENT_POST_SHARE_LINKED_IN)
  }

  return {
    propagateFacebookEvent,
    propagateMessengerEvent,
    propagateViberEvent,
    propagateWhatsAppEvent,
    propagateLinkedInEvent,
  }
}

export function usePostCopyManager(post: Post) {
  const { propagateAnalyticsEvent } = useAnalyticsManager()
  const copied = ref(false)
  const postRouteInput = ref<HTMLInputElement>()

  const copy = () => {
    if (postRouteInput.value) {
      postRouteInput.value.focus()
      postRouteInput.value.select()
      copied.value = document.execCommand('copy')
      postRouteInput.value.blur()
      propagateAnalyticsEvent(post, ANALYTICS_EVENT_POST_SHARE_LINK)
    }
  }

  return {
    copied,
    postRouteInput,
    copy,
  }
}
